<article class="slot-card">
  <div class="slot-document-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" focusable="false">
      <path
        d="M7 3.75h6.44a1.5 1.5 0 0 1 1.06.44l2.31 2.31a1.5 1.5 0 0 1 .44 1.06v11.69A1.5 1.5 0 0 1 15.75 20.75h-8.5a1.5 1.5 0 0 1-1.5-1.5v-14a1.5 1.5 0 0 1 1.5-1.5Zm6 1.81v2.19a.75.75 0 0 0 .75.75h2.19"
      />
      <path d="M8.75 11h5.5" />
      <path d="M8.75 14h5.5" />
      <path d="M8.75 17h3.5" />
    </svg>
  </div>

  <div class="slot-content">
    <header class="slot-header">
      <h4 class="slot-title">{{ example().name }}</h4>
      @if (example().description) {
        <comp-description
          [description]="example().description"
          [showMaxLines]="3"
        ></comp-description>
      }
    </header>

    <a class="slot-more-info" [href]="example().link" target="_blank" rel="noopener noreferrer">
      {{ 'general.moreInfo' | translate }}
    </a>
  </div>
</article>
